import {Injectable} from '@angular/core';
import {PlannedAction} from '@frontend/shared-api';
import {FunctionEntry, ModuleData} from '../system-recording.types';

@Injectable({providedIn: 'root'})
export class FunctionEntryService {
  updateFunctionEntry(
    modules: ModuleData[],
    uniqueId: string,
    updates: Partial<FunctionEntry>,
  ): ModuleData[] {
    return modules.map((module) => {
      return {
        ...module,
        functions: module.functions.map((func) =>
          func.uniqueId === uniqueId ? {...func, ...updates} : func,
        ),
      };
    });
  }

  isFunctionComplete(func: FunctionEntry): boolean {
    if (!func.plannedAction) {
      return false;
    }

    if (
      func.plannedAction === PlannedAction.NEW ||
      func.plannedAction === PlannedAction.NO_SYSTEM
    ) {
      return func.selectedOffices.length > 0;
    }

    return func.providerId !== null && func.toolId !== null && func.selectedOffices.length > 0;
  }

  handlePlannedActionChange(plannedAction: PlannedAction): Partial<FunctionEntry> {
    if (plannedAction === PlannedAction.NEW || plannedAction === PlannedAction.NO_SYSTEM) {
      return {
        plannedAction,
        toolId: null,
        providerId: null,
      };
    }

    return {plannedAction};
  }

  handleProviderChange(providerId: number): Partial<FunctionEntry> {
    return {
      providerId,
      toolId: null,
    };
  }

  duplicateFunctionInstance(
    modules: ModuleData[],
    moduleId: number,
    currentUniqueId: string,
  ): ModuleData[] {
    return modules.map((module) => {
      if (module.id === moduleId) {
        const currentFunction = module.functions.find((f) => f.uniqueId === currentUniqueId);
        if (currentFunction) {
          const newEntry: FunctionEntry = {
            ...currentFunction,
            uniqueId: crypto.randomUUID(),
            backendId: null,
            selectedOffices: [],
            plannedAction: null,
            toolId: null,
            providerId: null,
          };

          const currentIndex = module.functions.findIndex((f) => f.uniqueId === currentUniqueId);
          const newFunctions = [...module.functions];
          newFunctions.splice(currentIndex + 1, 0, newEntry);

          return {
            ...module,
            functions: newFunctions,
            hasInScopeFunctions: newFunctions.some((func) => func.isInProjectScope),
          };
        }
      }
      return module;
    });
  }

  removeFunctionInstance(
    modules: ModuleData[],
    moduleId: number,
    entryUniqueId: string,
  ): ModuleData[] {
    return modules.map((module) => {
      if (module.id === moduleId) {
        const newFunctions = module.functions.filter((func) => func.uniqueId !== entryUniqueId);

        return {
          ...module,
          functions: newFunctions,
          hasInScopeFunctions: newFunctions.some((func) => func.isInProjectScope),
        };
      }
      return module;
    });
  }
}
